import { put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import * as actions from '../store/options.actions'
import { getVitalOptionsSelector } from '../selectors'
import { IVitalOptionsState } from '../store/options.types'
import { VitalsConstants } from '../../vitals/store/vitals.constants'
import { IPatientVitals } from '../../vitals/store/vitals.types'
import { IRootState } from '../../../store'
import {
  buildCustomStrokeScaleScoreOptions,
  getAllowedStrokeScoreIds,
  IStrokeScaleConfigOption,
  IStrokeScaleScoreOption,
} from '../../initialAssessments/neuro/strokeScore/utils/strokeScaleScore.util'

export function* setVitalsCustomStrokeScoreScaleOptions() {
  try {
    const vitalsData: IPatientVitals = yield select((state: IRootState) => state.vitals)
    const vitalOptionsData: IVitalOptionsState = yield select(getVitalOptionsSelector)
    const { strokeScale } = vitalsData
    const { strokeScaleScoreOptions, strokeScaleConfigOptions } = vitalOptionsData

    if (strokeScale?.id) {
      const allowedScoreIds = getAllowedStrokeScoreIds(
        strokeScale.id,
        strokeScaleConfigOptions as IStrokeScaleConfigOption[]
      )
      const entity = buildCustomStrokeScaleScoreOptions(
        strokeScaleScoreOptions as IStrokeScaleScoreOption[],
        allowedScoreIds
      )
      yield put(actions.setVitalsCustomStrokeScoreScaleOptions(entity))
    }
  } catch (e) {
    yield put(throwPcrException(`setVitalsCustomStrokeScoreScaleOptions() error: ${e}`))
  }
}

export function* setVitalsCustomStrokeScoreScaleOptionsSaga() {
  yield takeLatest(
    [VitalsConstants.SET_STROKE_SCALE, VitalsConstants.SET_STATE],
    setVitalsCustomStrokeScoreScaleOptions
  )
}
